export const textareaToArray = (text) => {
  return text
    ?.replace(/\r\n/g, '\n')
    ?.replace(/\r/g, '\n')
    ?.split('\n')
    ?.map((line) => line.trim())
    ?.filter((line) => line);
};
